import React, { useState, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, TextField, IconButton, Paper, Typography, Tooltip, MenuItem, ListItemIcon } from "@mui/material";
import Iconn from '@mdi/react';
import { mdiCloseCircle, mdiLockReset } from "@mdi/js";
import '../css/login.css';
import '../css/global.css';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Draggable from "react-draggable";
import Icon from "@mdi/react";
import { paperPropsSmaller, paperPropsTick } from "../css/muiStyle";
import { axiosPostAction, axiosResponse } from "../Gfunc";
import { useAlert } from "../contexts/alertContext";
import DialogActionsComponent from "../compo/DialogActionsComponent";
import TitleComponent from "../compo/TitleComponent";


const DialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <MuiDialogTitle {...other}>
      <Typography>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" onClick={onClose}>
          <Iconn path={mdiCloseCircle} color="white" size="20px" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

function PaperComponent(props) {
  const ref = useRef(null);
  return (
    <Draggable
      nodeRef={ref}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={ref} />
    </Draggable>
  );
}



export default function ResetPwd(props) {
  const { showAlert } = useAlert();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(false);




  const handleClickOpen = () => {
    setOpen(true);
    setPassword("");
    setConfirmPassword("");
    setError(false);
  };

  const handleClose = () => { 
    setOpen(false);
    setPassword("");
    setConfirmPassword("");
    setError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password === confirmPassword && password !== "") {
      const data = {
        att: "password",
        id: localStorage.getItem("uid"),
        val: password,
      };
      const response = await axiosPostAction("_usr.php", "upd", data);
      if (response.data.err && response.data.err !== "-1") {
        showAlert(response.data.err, "error");
      } else {
        axiosResponse(response, () => {
          if (response.data.jData) {
            showAlert(response.data.err, "error");
          }
        });
      }
      handleClose();
    } else {
      setError(true);
    }
  };

  return (
    <>
      <MenuItem onClick={handleClickOpen}>
        <ListItemIcon><Icon path={mdiLockReset} color="grey" size="22px" /></ListItemIcon>
        Changer mot de passe
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          ...paperPropsTick,
          className: 'dialog-smaller',
        }}
        onKeyDown={(e) => {
          if (e.key === 'Tab') {
            e.stopPropagation();
          }
        }}
      >
        <DialogTitle id="draggable-dialog-title" className="dialog-title">
          <TitleComponent
            title=" Réinitialiser le mot de passe "
            icon={mdiLockReset}
            color="white"
          />
        </DialogTitle>
        <form id='resetPass' onSubmit={handleSubmit}>
          <DialogContent className="centered-container">
            <TextField
              id="pass"
              name="pass"
              error={error && (password === "" || password !== confirmPassword)}
              helperText={error && (password === "" ? "Veuillez saisir un nouveau mot de passe!" : "Les mots de passe ne correspondent pas!")}
              label='Nouveau mot de passe'
              type='password'
              value={password}
              variant='outlined'
              onChange={(e) => { setPassword(e.target.value); setError(false); }}
              required
              autoFocus
              onKeyDown={(e) => {
                if (e.key !== 'Tab') {
                  e.stopPropagation();
                }
              }}
            />
            <TextField
              fullWidth
              id="conf"
              name="confPass"
              error={error && (confirmPassword === "" || password !== confirmPassword)}
              helperText={error && (confirmPassword === "" ? "Veuillez confirmer votre nouveau mot de passe!" : "Les mots de passe ne correspondent pas!")}
              label='Confirmer le mot de passe'
              type='password'
              value={confirmPassword}
              variant='outlined'
              onChange={(e) => { setConfirmPassword(e.target.value); setError(false); }}
              required
              onKeyDown={(e) => {
                if (e.key !== 'Tab') {
                  e.stopPropagation();
                }
              }}
            />
          </DialogContent>
          <DialogActionsComponent
            onClose={handleClose}
            formId="resetPass"
            closeText="Fermer"
            validateText="Réinitialiser"
          />
        </form>
      </Dialog>
    </>
  );
}